import React from 'react';
import { useAnalyzePageHooks, usePropsMapper } from '../hooks';
import { LoadingScreen, HistoryDrawer, ModalContainer } from '../components';
import { MainLayoutContainer, PageHeader } from '../components/Layout';

const AnalyzePage = () => {
  const hooks = useAnalyzePageHooks();
  const props = usePropsMapper(hooks);

  if (!hooks.pageGuard.shouldRender) return <LoadingScreen />;

  return (
    <>
      <PageHeader {...props.pageHeaderProps} />
      <HistoryDrawer {...props.historyDrawerProps} />
      <MainLayoutContainer {...props.mainLayoutProps} />
      <ModalContainer {...props.modalProps} />
    </>
  );
};

export default AnalyzePage; 